// extracted by mini-css-extract-plugin
export default {"button":"styles_button__b5OZK","content":"styles_content__Dq45P","question":"styles_question__d+dQV"};